import { render, staticRenderFns } from "./List.vue?vue&type=template&id=6b67c0aa&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b67c0aa",
  null
  
)

export default component.exports